/* Free Shipping Bar — Bibi Home Decor Tecidos
 * Detecta zona pelo UF via ViaCEP e mostra progresso ate frete gratis.
 * Injeta na pagina de produto (antes da quantidade), no cart drawer e na pagina /cart.
 *
 * Estados (sem CEP):  teaser  -> (clica)  cep-row (input)
 * Estado (com CEP):   progress-row (barra + cidade + meta + caminhao)
 */
(function () {
  'use strict';

  /* UF -> minimo em centavos para frete gratis */
  var ZONES = {
    SP: 16900,
    MG: 19900, RJ: 19900, PR: 19900,
    RS: 24900, SC: 24900, DF: 24900, ES: 24900,
    BA: 39900, GO: 39900, MS: 39900, PA: 39900, PB: 39900, PE: 39900,
    MT: 69900, RN: 69900, RO: 69900, RR: 69900, TO: 69900,
    AC: 84900, AL: 84900, AM: 84900, AP: 84900,
    CE: 84900, MA: 84900, PI: 84900, SE: 84900
  };

  var STORAGE_KEY = 'bibi-fsb';
  var TRUCK_HALF_W = 13;

  var TRUCK_SVG = (
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect x="1" y="5" width="14" height="11" rx="1" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M15 9h5l3 4v4h-8V9z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<circle cx="5.5" cy="19" r="2" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="18.5" cy="19" r="2" stroke="currentColor" stroke-width="1.6"/>' +
    '</svg>'
  );

  var currentCart = 0;
  var injected = { product: false, drawer: false, cart: false };

  /* ---------- localStorage ---------- */
  function getCep() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch (e) { return null; }
  }
  function setCep(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }
  function clearCep() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ---------- ViaCEP ---------- */
  function lookupCep(cep, cb) {
    var clean = cep.replace(/\D/g, '');
    if (clean.length !== 8) { cb(null); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://viacep.com.br/ws/' + clean + '/json/');
    xhr.onload = function () {
      try {
        var d = JSON.parse(xhr.responseText);
        if (d && !d.erro && d.uf) {
          cb({ cep: clean, uf: d.uf.toUpperCase(), cidade: (d.localidade || '').toUpperCase() });
        } else { cb(null); }
      } catch (e) { cb(null); }
    };
    xhr.onerror = function () { cb(null); };
    xhr.send();
  }

  /* ---------- moeda ---------- */
  function money(cents) {
    var val = (cents / 100).toFixed(2);
    val = val.replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
    return 'R$ ' + val;
  }

  /* ---------- montar o bar (createElement; sem innerHTML em dado do usuario) ---------- */
  function buildBar(location) {
    var wrapper = document.createElement('div');
    wrapper.className = 'fsb-wrapper';
    wrapper.dataset.fsbBar = '';
    wrapper.dataset.location = location;

    /* --- TEASER (sem CEP) --- */
    var teaser = document.createElement('button');
    teaser.type = 'button';
    teaser.className = 'fsb-teaser';
    teaser.dataset.fsbTeaser = '';

    var tIcon = document.createElement('span');
    tIcon.className = 'fsb-teaser-icon';
    tIcon.setAttribute('aria-hidden', 'true');
    tIcon.textContent = '🎁'; /* presente */

    var tText = document.createElement('span');
    tText.className = 'fsb-teaser-text';
    tText.appendChild(document.createTextNode('Frete grátis esperando por você! '));
    var tStrong = document.createElement('strong');
    tStrong.textContent = 'Toque e veja quanto falta';
    tText.appendChild(tStrong);

    var tArrow = document.createElement('span');
    tArrow.className = 'fsb-teaser-arrow';
    tArrow.setAttribute('aria-hidden', 'true');
    tArrow.textContent = '→';

    teaser.appendChild(tIcon);
    teaser.appendChild(tText);
    teaser.appendChild(tArrow);

    /* --- CEP row (apos clicar no teaser) --- */
    var cepRow = document.createElement('div');
    cepRow.className = 'fsb-cep-row fsb-hidden';
    cepRow.dataset.fsbCepRow = '';

    var icon = document.createElement('span');
    icon.className = 'fsb-cep-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '🚚'; /* caminhao */

    var label = document.createElement('span');
    label.className = 'fsb-cep-label';
    label.textContent = 'Digite seu CEP:';

    var inputGroup = document.createElement('span');
    inputGroup.className = 'fsb-cep-input-group';

    var input = document.createElement('input');
    input.className = 'fsb-cep-input';
    input.type = 'text';
    input.setAttribute('inputmode', 'numeric');
    input.placeholder = '00000-000';
    input.maxLength = 9;
    input.setAttribute('autocomplete', 'postal-code');
    input.setAttribute('aria-label', 'CEP para frete grátis');

    var status = document.createElement('span');
    status.className = 'fsb-cep-status';
    status.dataset.fsbStatus = '';
    status.setAttribute('aria-live', 'polite');

    inputGroup.appendChild(input);
    inputGroup.appendChild(status);

    var errorEl = document.createElement('span');
    errorEl.className = 'fsb-cep-error fsb-hidden';
    errorEl.dataset.fsbError = '';
    errorEl.setAttribute('role', 'alert');

    cepRow.appendChild(icon);
    cepRow.appendChild(label);
    cepRow.appendChild(inputGroup);
    cepRow.appendChild(errorEl);

    /* --- Progress row (com CEP) --- */
    var progRow = document.createElement('div');
    progRow.className = 'fsb-progress-row fsb-hidden';
    progRow.dataset.fsbProgressRow = '';

    var msg = document.createElement('div');
    msg.className = 'fsb-msg';
    msg.dataset.fsbMsg = '';

    var msgText = document.createElement('span');
    msgText.className = 'fsb-msg-text';
    msgText.dataset.fsbMsgText = '';

    msg.appendChild(msgText);

    var goal = document.createElement('span');
    goal.className = 'fsb-goal';
    goal.dataset.fsbGoal = '';

    var track = document.createElement('div');
    track.className = 'fsb-bar-track';

    var fill = document.createElement('div');
    fill.className = 'fsb-bar-fill';
    fill.dataset.fsbFill = '';
    fill.style.width = '0%';

    var truck = document.createElement('span');
    truck.className = 'fsb-truck';
    truck.dataset.fsbTruck = '';
    truck.style.left = '0px';
    truck.innerHTML = TRUCK_SVG; /* SVG estatico, sem dado do usuario */

    track.appendChild(fill);
    track.appendChild(truck);

    var changeBtn = document.createElement('button');
    changeBtn.className = 'fsb-change-cep';
    changeBtn.dataset.fsbChange = '';
    changeBtn.type = 'button';
    changeBtn.textContent = 'Mudar CEP';

    /* barra (com a meta no canto) em CIMA; texto embaixo (como a inspiracao) */
    var barRow = document.createElement('div');
    barRow.className = 'fsb-bar-row';
    barRow.appendChild(track);
    barRow.appendChild(goal);

    progRow.appendChild(barRow);
    progRow.appendChild(msg);
    progRow.appendChild(changeBtn);

    wrapper.appendChild(teaser);
    wrapper.appendChild(cepRow);
    wrapper.appendChild(progRow);

    return wrapper;
  }

  /* ---------- montar mensagem (com cidade + meta) ---------- */
  function setMsg(msgEl, msgText, goal, state, rest, threshold, cidade) {
    msgText.textContent = '';
    msgEl.classList.remove('fsb-msg--done');
    goal.textContent = money(threshold);

    /* destaque colorido fica na RECOMPENSA (ganhe frete gratis + cidade) */
    var reward = document.createElement('span');
    reward.className = 'fsb-reward';

    if (state === 'done') {
      msgEl.classList.add('fsb-msg--done');
      msgText.appendChild(document.createTextNode('🎉 '));
      reward.textContent = cidade ? 'FRETE GRÁTIS GARANTIDO (' + cidade + ')' : 'FRETE GRÁTIS GARANTIDO';
      msgText.appendChild(reward);
      msgText.appendChild(document.createTextNode(' 🚚'));
    } else {
      msgText.appendChild(document.createTextNode('Adicione mais '));
      var strong = document.createElement('strong');
      strong.textContent = money(rest);
      msgText.appendChild(strong);
      msgText.appendChild(document.createTextNode(' e '));
      reward.textContent = cidade ? 'GANHE FRETE GRÁTIS (' + cidade + ')' : 'GANHE FRETE GRÁTIS';
      msgText.appendChild(reward);
      msgText.appendChild(document.createTextNode(' 🚚'));
    }
  }

  /* ---------- atualizar um bar ---------- */
  function updateBar(bar, total) {
    var cepData = getCep();
    var teaser  = bar.querySelector('[data-fsb-teaser]');
    var cepRow  = bar.querySelector('[data-fsb-cep-row]');
    var progRow = bar.querySelector('[data-fsb-progress-row]');

    if (!cepData) {
      progRow.classList.add('fsb-hidden');
      delete bar.dataset.state;
      if (bar.dataset.cepOpen === '1') {
        teaser.classList.add('fsb-hidden');
        cepRow.classList.remove('fsb-hidden');
      } else {
        teaser.classList.remove('fsb-hidden');
        cepRow.classList.add('fsb-hidden');
      }
      return;
    }

    var threshold = ZONES[cepData.uf];
    if (threshold === undefined) {
      var container = bar.closest('.fsb-container');
      if (container) container.style.display = 'none';
      return;
    }

    teaser.classList.add('fsb-hidden');
    cepRow.classList.add('fsb-hidden');
    progRow.classList.remove('fsb-hidden');

    var pct  = Math.min(100, Math.floor(total * 100 / threshold));
    var rest = Math.max(0, threshold - total);
    var fill    = bar.querySelector('[data-fsb-fill]');
    var truck   = bar.querySelector('[data-fsb-truck]');
    var msg     = bar.querySelector('[data-fsb-msg]');
    var msgText = bar.querySelector('[data-fsb-msg-text]');
    var goal    = bar.querySelector('[data-fsb-goal]');

    fill.style.width = pct + '%';
    truck.style.left = 'calc(' + pct + '% - ' + TRUCK_HALF_W + 'px)';

    var state;
    if (pct >= 100)     state = 'done';
    else if (pct >= 70) state = 'almost';
    else if (pct > 0)   state = 'progress';
    else                state = 'idle';

    bar.dataset.state = state;
    setMsg(msg, msgText, goal, state, rest, threshold, cepData.cidade);
  }

  /* ---------- atualizar todos ---------- */
  function updateAll(total) {
    currentCart = total;
    document.querySelectorAll('[data-fsb-bar]').forEach(function (bar) {
      updateBar(bar, total);
    });
  }

  /* ---------- handlers ---------- */
  function attachHandlers(bar) {
    var teaser    = bar.querySelector('[data-fsb-teaser]');
    var input     = bar.querySelector('.fsb-cep-input');
    var status    = bar.querySelector('[data-fsb-status]');
    var errorEl   = bar.querySelector('[data-fsb-error]');
    var changeBtn = bar.querySelector('[data-fsb-change]');

    if (teaser) {
      teaser.addEventListener('click', function () {
        bar.dataset.cepOpen = '1';
        updateBar(bar, currentCart);
        var inp = bar.querySelector('.fsb-cep-input');
        if (inp) inp.focus();
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        var raw = input.value.replace(/\D/g, '').slice(0, 8);
        input.value = raw.length > 5 ? raw.slice(0, 5) + '-' + raw.slice(5) : raw;

        errorEl.classList.add('fsb-hidden');
        errorEl.textContent = '';

        if (raw.length === 8) {
          status.textContent = '⏳';
          lookupCep(raw, function (data) {
            if (data) {
              status.textContent = '✓';
              bar.dataset.cepOpen = '0';
              setCep(data);
              updateAll(currentCart);
            } else {
              status.textContent = '';
              errorEl.textContent = 'CEP não encontrado. Verifique e tente de novo.';
              errorEl.classList.remove('fsb-hidden');
            }
          });
        } else {
          status.textContent = '';
        }
      });
    }

    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        clearCep();
        bar.dataset.cepOpen = '1';
        updateAll(currentCart);
        setTimeout(function () {
          var inp = bar.querySelector('.fsb-cep-input');
          if (inp) { inp.value = ''; inp.focus(); }
        }, 60);
      });
    }

    updateBar(bar, currentCart);
  }

  /* ---------- injecao generica ---------- */
  function inject(target, location, position) {
    var container = document.createElement('div');
    container.className = 'fsb-container fsb-container--' + location;
    var bar = buildBar(location);
    container.appendChild(bar);

    if (position === 'before') {
      target.parentNode.insertBefore(container, target);
    } else if (position === 'after') {
      target.parentNode.insertBefore(container, target.nextSibling);
    } else if (position === 'prepend') {
      target.insertBefore(container, target.firstChild);
    }

    attachHandlers(bar);
    injected[location] = true;
  }

  /* ---------- Produto: ANTES da quantidade (largura total) ---------- */
  function tryProduct() {
    if (injected.product) return;
    var target = document.querySelector('variant-picker') ||
                 document.querySelector('.buy-buttons-block') ||
                 document.querySelector('add-to-cart-component');
    if (target) inject(target, 'product', 'before');
  }

  /* ---------- Cart drawer ---------- */
  function tryDrawer() {
    if (injected.drawer) return;
    var itemsEl = document.querySelector('.cart-drawer__items');
    if (itemsEl) {
      inject(itemsEl, 'drawer', 'before');
      return;
    }
    var drawerCmp = document.querySelector('cart-items-component');
    if (drawerCmp) inject(drawerCmp, 'drawer', 'prepend');
  }

  /* ---------- Pagina /cart ---------- */
  function tryCartPage() {
    if (injected.cart) return;
    var anchor = document.querySelector('.cart-page__items') ||
                 document.querySelector('.cart-page__title');
    if (anchor) inject(anchor, 'cart', 'before');
  }

  /* ---------- revalidar injecao (view-transition pode remover) ---------- */
  function recheckInjected() {
    injected.drawer  = !!document.querySelector('[data-fsb-bar][data-location="drawer"]');
    injected.cart    = !!document.querySelector('[data-fsb-bar][data-location="cart"]');
    injected.product = !!document.querySelector('[data-fsb-bar][data-location="product"]');
  }

  /* ---------- total via /cart.js ---------- */
  function fetchCart(cb) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js');
    xhr.onload = function () {
      try { cb(JSON.parse(xhr.responseText).total_price || 0); }
      catch (e) { cb(0); }
    };
    xhr.onerror = function () { cb(0); };
    xhr.send();
  }

  /* ---------- init ---------- */
  function init() {
    fetchCart(function (total) {
      currentCart = total;

      var main = document.querySelector('main[data-template]');
      var tmpl = main ? main.dataset.template : '';

      if (tmpl === 'product') tryProduct();
      if (tmpl === 'cart')    tryCartPage();

      tryDrawer();

      var observer = new MutationObserver(function () {
        recheckInjected();
        tryDrawer();
        attachDrawerOpen();
        if (tmpl === 'product') tryProduct();
        if (tmpl === 'cart')    tryCartPage();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });

    document.addEventListener('cart:update', function (e) {
      var resource = e && e.detail && e.detail.resource;
      if (resource && typeof resource.total_price === 'number') {
        recheckInjected();
        tryDrawer();
        updateAll(resource.total_price);
      }
    });

    /* Horizon dispara 'dialog:open' no proprio cart-drawer-component (NAO borbulha) */
    function onDrawerOpen() {
      recheckInjected();
      tryDrawer();
      document.querySelectorAll('[data-fsb-bar][data-location="drawer"]').forEach(function (bar) {
        updateBar(bar, currentCart);
      });
    }
    function attachDrawerOpen() {
      var drawerCmp = document.querySelector('cart-drawer-component');
      if (drawerCmp) {
        /* botao unico: abre o carrinho ao adicionar (o tema le este atributo) */
        if (!drawerCmp.hasAttribute('auto-open')) drawerCmp.setAttribute('auto-open', '');
        if (!drawerCmp.dataset.fsbDrawerBound) {
          drawerCmp.dataset.fsbDrawerBound = '1';
          drawerCmp.addEventListener('dialog:open', onDrawerOpen);
        }
      }
    }
    attachDrawerOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
